import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  information = {
    name: 'Juan Felizzola',
    photo: '',
    socialMedia: {
      facebook: 'https://facebook.com/juankfelizzola',
      twitter: 'https://twitter.com/juancafelizzola'
    },
    description: 'Emprendedor, músico e investigador.',
    about: `Integrante de la Comunidad Desarrolladores Web UTS,
            en la cual me destaco por dictar diferentes talleres
            de Desarrollo Web y Marca Personal.`
  }

  constructor() { }

  ngOnInit() {
  }

}
